type GetContentFieldProps = {
  data: any;
  title?: string;
  type?: string;
};

export const getContentField = ({
  data,
  title,
  type,
}: GetContentFieldProps) => {
  let res = data?.reference || data?.fields?.reference || null;

  const getContentTitle = (data) => {
    return data?.fields?.title || null;
  };
  const getContentType = (data) => {
    return data?.sys?.contentType?.sys?.id || null;
  };
  const getFieldType = (data) => {
    return data?.sys?.contentType?.sys?.id || null;
  };

  if (type) {
    res = res?.find((v) => getContentType(v) === type)?.fields || null;
    if (['heading', 'paragraph', 'small'].indexOf(type) > -1)
      res = res?.paragraph || null;
    if (type === 'poster') res = res?.image || res?.poster || null;
    return res;
  }

  if (title) {
    res = res?.find((v) => getContentTitle(v) === title) || null;
    if (['heading', 'paragraph', 'small'].indexOf(getFieldType(res)) > -1)
      return res?.fields?.paragraph || null;
    return res?.fields;
  }

  return res;
};
